//This will import all default material vuetify colors and rename them to match tailwindcss
import colors from 'vuetify/lib/util/colors';

// TireVault design tokens — sourced from the design prototype (prototype/, gitignored)
const tailwindColors = {
    transparent: {
        DEFAULT: 'transparent'
    },
    white: {
        DEFAULT: '#ffffff',
    },
    black: {
        DEFAULT: '#000000',
    },
    primary: {
        DEFAULT: '#123F63',
        light: '#1D5585',
        dark: '#0E3350',
        deep: '#0B2C46',
    },
    secondary: {
        DEFAULT: '#1596B0',
        light: '#3FB6CE',
        dark: '#0F7A90',
        soft: '#E3F3F6',
    },
    accent: {
        DEFAULT: '#1596B0',
        soft: '#E3F3F6',
    },
    success: {
        DEFAULT: '#1E8E5A',
        light: '#2FAE74',
        dark: '#166B44',
        soft: '#E6F4ED',
    },
    info: {
        DEFAULT: '#2E7CD6',
        light: '#5B99E0',
        dark: '#2261AC',
        soft: '#E8F1FB',
    },
    error: {
        DEFAULT: '#C23B34',
        light: '#D4655F',
        dark: '#9C2F29',
        soft: '#FAE9E8',
    },
    warning: {
        DEFAULT: '#B36F10',
        light: '#D18A1F',
        dark: '#8C570C',
        soft: '#FAF0DE',
    },
    winter: {
        DEFAULT: '#2E7CD6',
        soft: '#E8F1FB',
    },
    summer: {
        DEFAULT: '#E07B2A',
        soft: '#FBEFE3',
    },
    canvas: {
        DEFAULT: '#F4F7FA',
    },
    surface: {
        DEFAULT: '#FFFFFF',
    },
    line: {
        DEFAULT: '#DDE5EC',
    },
    ink: {
        DEFAULT: '#152431',
        light: '#5A6B7A',
    },
    gray: {
        DEFAULT: '#5A6B7A',
        light: '#DDE5EC',
        dark: '#152431'
    },
};

function renameKeys(obj, newKeys) {
    const keyValues = Object.keys(obj).map(key => {
        const newKey = newKeys[key] || key;
        return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
}

// Define your original object
let tailwindMaterialColorPack = colors;

// Define the new key mapping
const tailwindMap = {
    lighten5: '100',
    lighten4: '200',
    lighten3: '300',
    lighten2: '400',
    lighten1: '500',
    darken1: '600',
    darken2: '700',
    darken3: '800',
    darken4: '900',
    accent1: 'accent-100',
    accent2: 'accent-200',
    accent3: 'accent-300',
    accent4: 'accent-400',
    base: 'DEFAULT',
};

// Apply the function to each color object
Object.keys(tailwindMaterialColorPack).forEach(color => {
    tailwindMaterialColorPack[color] = renameKeys(tailwindMaterialColorPack[color], tailwindMap);
    tailwindMaterialColorPack[color].base = tailwindMaterialColorPack[color].DEFAULT;
});

// const tailwindColorFormatted = {};

// Object.keys(tailwindColors).forEach(color => {
//     tailwindColorFormatted[`${color}`] = tailwindColors[color]['DEFAULT'];
//     tailwindColorFormatted[`${color}-100`] = tailwindColors[color]['100'];
// });

// Merge the two objects
tailwindMaterialColorPack = { ...tailwindMaterialColorPack, ...tailwindColors };

export const colorConfig = tailwindMaterialColorPack;
